import * as React from 'react';
import SVGInline from 'react-svg-inline';
import * as classnames from 'classnames/bind';

import styles from './PeopleSection.scss';
import Card from '../../Card/Card';
import { PeopleSectionLocale } from './peopleSection.locale';
import quotes from '../../Icon/quotes.svg';
import ivetaImg from './iveta.png';
import jiriImg from './jiri.png';
import janImg from './jan.png';

const cx = classnames.bind(styles);

export type PersonKeys = 'iveta' | 'jiri' | 'jan';

export interface FlippedCards {
  iveta?: boolean;
  jiri?: boolean;
  jan?: boolean;
}

interface PeopleSectionProps {
  locale: PeopleSectionLocale;
  flippedCards: FlippedCards;
  flipCard: (key: PersonKeys) => void;
}

const PeopleSection: React.SFC<PeopleSectionProps> = ({ locale, flippedCards, flipCard }) => {
  const renderPerson = (
    personKey: PersonKeys,
    image: string,
    side: 'right' | 'left',
    className: string = '',
  ) => (
    <div
      className={`w-100 mt-5 mt-sm-7 mt-md-8 ${className} ${styles.perspective}`}
      onClick={() => flipCard(personKey)}
    >
      <div
        className={cx('position-relative', 'cardsContainer', {
          backsideIsVisible: flippedCards[personKey],
        })}
      >
        <div className={`${styles.personContainer} ${styles[side]}`}>
          <Card bubble={side}>
            <div className={styles.cardContent}>
              <div className={styles.quotes}>
                <SVGInline svg={quotes} component="div" className="d-flex" />
              </div>
              <img
                src={image}
                alt={locale[personKey].name}
                className={`${styles.personImg} ${styles[personKey]}`}
              />
              <div className="w-100">
                <p className="d-none d-sm-block mb-4">{locale[personKey].description}</p>
                <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start">
                  <h6 className="m-0 mr-sm-3 font-weight-bold">{locale[personKey].name}</h6>
                  <div className="w-100 d-sm-none" />
                  <span className={styles.job}>{locale[personKey].job}</span>
                </div>
              </div>
            </div>
          </Card>
        </div>
        <div className={`${styles.personContainer} ${styles.backside} d-sm-none`}>
          <Card>
            <div className={styles.cardContent}>
              <p>{locale[personKey].description}</p>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.peopleSection}>
      {renderPerson('iveta', ivetaImg, 'left')}
      {renderPerson('jiri', jiriImg, 'right', 'ml-lg-8')}
      {renderPerson('jan', janImg, 'left', 'mr-lg-8 align-self-end')}
    </div>
  );
};

export default PeopleSection;



// WEBPACK FOOTER //
// /www/client/src/components/AboutPage/PeopleSection/PeopleSection.tsx